import axiosInstance from '../axiosInterceptor/axiosInstance'

const getRecentLivestreams = async (data) => {
  const { orgId, limit } = data
  // The org's streams, newest first.
  const url = `v1/orgs/${orgId}/streams?limit=${limit}`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getRecentLivestreams
